// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XWLf","left":"styles_left__35pou"};